/**
 * How many items from `heights` fit inside `available` pixels.
 *
 * Used by the blog page to stop the related-posts sidebar running past the end
 * of the article — it rendered a fixed five cards, so a short post left a long
 * empty gap beside them.
 *
 * Always returns at least 1 when there is anything to show: an empty sidebar
 * beside a very short post looks broken rather than tidy.
 *
 * @param {number[]} heights   each item's rendered height, in order
 * @param {number}   available height to fill, in pixels
 * @returns {number} how many leading items fit
 */
export const countThatFit = (heights, available) => {
  const list = Array.isArray(heights) ? heights : [];
  if (list.length === 0) return 0;
  if (!(available > 0)) return list.length;

  let used = 0;
  let fit = 0;
  for (let i = 0; i < list.length; i += 1) {
    const height = Number(list[i]) || 0;
    // Keep the first card even if it alone overflows — better than nothing.
    if (fit > 0 && used + height > available) break;
    used += height;
    fit += 1;
  }
  return fit;
};
